import { format } from "date-fns";
import { CalendarIcon } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Calendar } from "@/components/ui/calendar";

const toDate = (iso) => (iso ? new Date(`${iso}T12:00:00`) : undefined);
const toIso = (d) => (d ? format(d, "yyyy-MM-dd") : null);

/** shadcn Calendar inside a Popover, stores yyyy-MM-dd strings. */
export const DateField = ({ value, onChange, placeholder = "Pick a date", disablePast = true, testId }) => (
  <Popover>
    <PopoverTrigger asChild>
      <button
        type="button"
        data-testid={testId}
        className="flex h-11 w-full items-center justify-between rounded-md border border-input bg-white px-3 text-left text-[15px] transition-colors hover:border-ink focus:outline-none focus-visible:ring-2 focus-visible:ring-ring"
      >
        <span className={value ? "text-ink" : "text-neutral-500"}>{value ? format(toDate(value), "PPP") : placeholder}</span>
        <CalendarIcon className="h-4 w-4 text-neutral-500" />
      </button>
    </PopoverTrigger>
    <PopoverContent className="w-auto p-0" align="start">
      <Calendar
        mode="single"
        selected={toDate(value)}
        onSelect={(d) => onChange(toIso(d))}
        disabled={disablePast ? { before: new Date() } : undefined}
        initialFocus
      />
    </PopoverContent>
  </Popover>
);
